let claimsCols = [
    {
        key: 'insuranceLineName',
        display: 'Insurance Line'
    },
    {
        key: 'resellerName',
        display: 'Reseller'
    },
    {
        key: 'underwriterName',
        display: 'Underwriter'
    },
    {
        key: 'countryCode',
        display: 'Country'
    },
    {
        key: 'claimReference',
        display: 'Claim Reference'
    },
    {
        key: 'relatedReference',
        display: 'Related Reference'
    },
    {
        key: 'productName',
        display: 'Product'
    },
    {
        key: 'claimType',
        display: 'Claim Type'
    },
    {
        key: 'dateCreated',
        display: 'Claim Submitted Date'
    },
    {
        key: 'incidentDate',
        display: 'Incident Date'
    },
    {
        key: 'number',
        display: 'Policy Number'
    },
    {
        key: 'email',
        display: 'Claimant'
    },
    {
        key: 'claimStatus',
        display: 'Claim Status'
    },
    {
        key: 'claimDecision',
        display: 'Claim Decision'
    },
    {
        key: 'imeiNos',
        display: 'IMEIs'
    },
    {
        key: 'serailNos',
        display: 'Serials'
    }
]

export { claimsCols }